// src/components/Modal.js
import React from 'react';
import { X } from 'lucide-react'; // Optional: Replace with '✖' if you don't use lucide-react

const ICONS = {
    error: '❌',
    success: '✅',
    warning: '⚠️',
    info: 'ℹ️',
};

const Modal = ({
    title = 'Notification',
    message = '',
    isOpen = false,
    onClose,
    type = 'error', // 'error' | 'success' | 'warning' | 'info'
    showConfirm = false,
    onConfirm,
    confirmText = 'Yes',
    cancelText = 'No',
}) => {
    if (!isOpen) return null;

    const icon = ICONS[type] || ICONS['info'];
    const headerColor =
        type === 'error'
            ? 'text-red-600'
            : type === 'success'
                ? 'text-green-600'
                : type === 'warning'
                    ? 'text-yellow-600'
                    : 'text-blue-600';

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-lg max-w-lg w-full animate-fade-in flex flex-col min-h-[250px]">
                {/* Header */}
                <div className="flex justify-between items-center border-b px-6 py-4">
                    <div className={`text-xl font-semibold flex items-center gap-2 ${headerColor}`}>
                        <span>{icon}</span> {title}
                    </div>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-800 text-xl"
                    >
                        <X size={20} />
                    </button>
                </div>

                {/* Message Body (Scrollable) */}
                <div className="overflow-y-auto max-h-[300px] py-4 px-6 text-sm whitespace-pre-wrap text-gray-700 flex-grow">
                    {message}
                </div>

                {/* Sticky Footer */}
                <div className="border-t px-6 py-4 flex justify-end space-x-2 bg-white">
                    {showConfirm ? (
                        <>
                            <button
                                onClick={onClose}
                                className="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400"
                            >
                                {cancelText}
                            </button>
                            <button
                                onClick={onConfirm}
                                className={`${type === 'error'
                                        ? 'bg-red-600 hover:bg-red-700'
                                        : type === 'success'
                                            ? 'bg-green-600 hover:bg-green-700'
                                            : type === 'warning'
                                                ? 'bg-yellow-500 hover:bg-yellow-600'
                                                : 'bg-blue-600 hover:bg-blue-700'
                                    } text-white px-4 py-2 rounded`}
                            >
                                {confirmText}
                            </button>
                        </>
                    ) : (
                        <button
                            onClick={onClose}
                            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                        >
                            Close
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Modal;
